module.exports = "<div class=\"dialog success-dialog\">\n  <h2 mat-dialog-title><span class=\"message\">{{ message }}</span></h2>\n  <mat-dialog-content>\n    <mat-icon [@fadeIn]>check</mat-icon>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button mat-dialog-close tabindex=\"-1\">Dismiss</button>\n  </mat-dialog-actions>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/success-dialog.component.html
// module id = ./src/app/shared/success-dialog.component.html
// module chunks = main